const formatadorDeMoeda = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'})

const formatadorDeQuantidade = new Intl.NumberFormat('pt-BR')

export const formatarMoeda = (valor: number): string => formatadorDeMoeda.format(valor)

export const formatarQuantidade = (valor: number): string => formatadorDeQuantidade.format(valor)

const TAMANHO_CNPJ = 14

const TAMANHO_CEP = 8

const somenteDigitos = (valor: string): string => valor.replace(/\D/g, '')

export const formatarCnpj = (valor: string): string => {
    const digitos = somenteDigitos(valor)
    if (digitos.length !== TAMANHO_CNPJ) return valor

    return digitos.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
}

export const formatarCep = (valor: string): string => {
    const digitos = somenteDigitos(valor)
    if (digitos.length !== TAMANHO_CEP) return valor

    return digitos.replace(/^(\d{5})(\d{3})$/, '$1-$2')
}
